import React from 'react';

export default function IndexTableFiltersPanelScalarDate(props) {

    let value = props.value;
    if (Array.isArray(props.value)) //TODO: why sometimes is array?
    {
        value = props.value[props.value.length - 1];
    }
    let value1 = value.value1 || "";
    let value2 = value.value2 || "";

    let rnd = Math.random().toString().substring(2, 11) + "-";

    const onValueChange = (event, index) => {

        let rnd = event.target.id.substring(0, 10);
        let val1 = document.getElementById(rnd + "val1").value;
        let val2 = document.getElementById(rnd + "val2").value;


        props.onChange({
            text: index === 0 ? '> ' + val1 : '< ' + val2,
            value: {value1: val1, value2: val2},
            index

        });
    }

    return (
        <div className="filters-panel-input range">
            <span title={props.label}>{props.label}</span>
            <div className="inputs">
                <span className="range-input val1">
                    <input type="date" id={rnd + "val1"} value={value1} onChange={e => onValueChange(e, 0)}/>
                </span>
                <span className="range-input val2">
                    <input type="date" id={rnd + "val2"} value={value2} onChange={e => onValueChange(e, 1)}/>
                </span>
            </div>
        </div>
    )
}